import { gsap, Power2 } from 'gsap'
import initSlider from '../../includes/Slider/assets/js/slider'

document.querySelectorAll('a').forEach(el =>
{
	el.addEventListener('click', e =>
	{
		const isProjectLink = el.href.indexOf('/projets/') !== -1
		
		if (isProjectLink)
		{
			e.preventDefault()
			
			const data = `url=${el.href}&action=getProjectPhotos&security=${app_params.app_nonce}`
			
			/*const galleryContainer = document.createElement('div')
			galleryContainer.id = 'galleryContainer'
			
			document.body.appendChild(galleryContainer)*/
			
			const galleryContainer = document.querySelector('#galleryContainer')
			
			initGallery()
			
			req(data).then((response) =>
			{
				if (!response.success)
				{
					hideGallery()
					
					return
				}
				
				galleryContainer.classList.add('loaded')
				galleryContainer.innerHTML = response.data
				
				initGallerySlider()
			})
		}
	})
})

function hideGallery (){
	const galleryContainer = document.querySelector('#galleryContainer')
	
	gsap.to(galleryContainer, {
		y: 0,
		opacity: 0,
		duration: .3,
		ease: Power2.easeOut,
		onComplete: ()=>{
			gsap.set(galleryContainer, {
				zIndex: -1
			})
			
			galleryContainer.classList.remove('loaded')
			galleryContainer.innerHTML = ''
		}
	})
}

function initGallery (){
	const galleryContainer = document.querySelector('#galleryContainer')
	
	gsap.fromTo(galleryContainer, {
		y: 0,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: .3,
		ease: Power2.easeOut,
		onStart: () =>
		{
			gsap.set(galleryContainer, {
				zIndex: 9999
			})
		},
	})
}

function initGallerySlider ()
{
	const galleryContainer = document.querySelector('#galleryContainer')
	const gallery = galleryContainer.querySelector('#gallery')
	
	gallery.querySelectorAll('.slider').forEach(el => {
		initSlider(el)
	})
	
	const els = gallery.querySelectorAll('.slider, .slider.photo .swiper-container, .slider.photo .swiper-button-prev, .slider.photo .swiper-button-next, .slider.thumbnails .item, .close');
	
	els.forEach((el, index) =>
	{
		gsap.fromTo(el, {
			y: 50,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: .3,
			delay: index * 0.1,
			ease: Power2.easeOut
		})
	})
	
	gallery.querySelector('.close').addEventListener('click', () =>
	{
		els.forEach((el, index) =>
		{
			gsap.to(el, {
				y: 0,
				opacity: 0,
				duration: .3,
				//delay: index * 0.1,
				ease: Power2.easeOut,
				onComplete: () =>
				{
					hideGallery()
				}
			})
		})
	})
}

async function req (data)
{
	return await fetch(app_params.ajax_url, {
		method: 'POST',
		body: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
			'X-Requested-With': 'XMLHttpRequest'
		}
	}).then((response) =>
	{
		return response.ok ? response.json() : Promise.reject(response.statusText)
	}).then((response) =>
	{
		return response
	}).catch((error) =>
	{
		alert(error)
	})
}
